import _ from "lodash"
import moment from "moment"
import "moment/locale/pt-br"
import { chaveArmazenamentoIdSessao } from "./Constantes"

export function formatarCpf(cpf, valorPadrao) {
	if (cpf) {
		cpf = cpf.replace(/[^\d]/g, "")
		return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
	}

	return valorPadrao ? valorPadrao : ""
}

export const converterStringToByteArray = (string, decodificar64) => {
	let byteCharacters = string;
	if (decodificar64) byteCharacters = atob(string);
  
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
	  byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	return byteArray;
  };

export const fazerDownloadDeArquivo = (bytes, nomeArquivo, decodificar64 = true) => {
	const byteArray = converterStringToByteArray(bytes, decodificar64);
	const url = window.URL.createObjectURL(new Blob([byteArray]));
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", nomeArquivo);
	link.click();
	window.URL.revokeObjectURL(url);
	link.remove();
  };

export const formatarUrlComSessionId = (url) => {
	return url + localStorage.getItem(chaveArmazenamentoIdSessao)
}

export const formatarNome = (nome) => {
	return !nome ? "" : _.startCase(_.camelCase(nome))
}

export const formatarCampoVazio = (nome) => {
	return !nome ? "- -" : nome
}

export const formatarTemperatura = (temperatura) => {
	return temperatura || temperatura === 0 ? `${temperatura}ºC` : '- -'
}

export const formatarUpperCase = (nome) => {
	return !nome ? "" : nome.toUpperCase()
}

export const formatarTitleCase = (nome) => {
	return !nome ? "" : nome.substring(0, 1).toUpperCase().concat(nome.substring(1).toLowerCase());
}

export const formatarCodigoLote = (nome) => {
	return !nome ? "" : nome.toString().padStart(12, "0");
}

export const limitarTexto = (texto, tam, sulfixo) => {
	return _.truncate(texto, {
		length: tam,
		omission: sulfixo,
	})
}

export const formatarDataEHora = (data) => {
	return data ? moment(data).format("DD/MM/YYYY HH:mm") : "- -"
}

export const formatarData = (data) => {
	return data ? moment(data).format("DD/MM/YYYY") : null
}

export const formatarDataNomeArquivo = (data) => {
	return data ? moment(data).format("DD-MM-YYYY") : null
}

export const formatarHora = (data) => {
	return data ? moment(data).format("HH:mm") + "h" : null
}

export const formatarDataRequisicao = (data) => {
	return data ? moment(data).format("YYYY-MM-DD") : null
}

export const formatarDataEHoraConcatenados = (data) => {
	return data ? moment(data).format("DDMMYYYYHHmm") : null
}

export const formatarValorMonetario = (str) => {
	if (!str) {
		if (str === 0) return "R$ - -";
		return null;
	}

	return str.toLocaleString("pt-br", { style: "currency", currency: "BRL" })
}

export const formatarPorcentagem = (str) => {
	if (!str) {
		if (str === 0) return "- -";
		return null;
	}

	return str.toLocaleString("pt-br", { style: "percent" })
}

export const formatarInteiro = (str) => {
	if (!str) return "- -";
	return parseInt(str);
}

export const formatarValorDecimal = (str) => {
	if (!str && str === 0) return "0%"

	const valor = str.toLocaleString("pt-br")

	return valor.concat("%")
}

export const formatarValorCasasDecimais = (str) => {

	const valor = str.toLocaleString("pt-br")

	return valor
}

export const formatarNomeSobrenome = (nome) => {
	return nome.split(/(\s).+\s/).join("")
}

export const getOptionSolicitantesValue = option => {
	return option.id;
  };
  
  export const getOptionSolicitantesLabel = option => {
	return `${option.nome} - ${option.siglaConselho} ${option.numeroConselho}  / ${option.ufConselho}`;
  };
